import React from 'react';
import { StmLogoContainer, stmLogoImg } from './styles';

export const DATA_QA_STM_LOGO = 'stm-logo';
export const DATA_QA_STM_LOGO_IMAGE = 'stm-logo-image';

export interface StmLogoProps {
  img: string;
  imgRetina: string;
  link: string;
  alt: string;
}

export const StmLogo: React.FC<StmLogoProps> = ({ img, imgRetina, link, alt }) => (
  <StmLogoContainer href={link} data-qa={DATA_QA_STM_LOGO}>
    <img className={stmLogoImg} alt={alt} src={img} srcSet={imgRetina} data-qa={DATA_QA_STM_LOGO_IMAGE} />
  </StmLogoContainer>
);
